export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11398.ab1ff717.jpg";